export default "__VITE_ASSET__D_8H8TFg__"